import { IFormReadonlyModelAccessor } from "../../Form/IFormModelAccessor";
import { DigestQueryFilter } from "../../../../../Common/CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { IterUtils } from "../../../../../Common/IterableUtils";
import { MaskResolver } from "../PathUtils/MaskResolver";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { PicklistDataItem, PicklistQueryResponse } from "./PicklistTypes";
import { gPathFilter } from "./GPathFilter";
import { IPicklist } from "./IPicklist";

export class InnerPathsPicklist implements IPicklist {
    private readonly paths: readonly AbsoluteModelPath[];
    private readonly modelAccessor: IFormReadonlyModelAccessor;

    public constructor(modelAccessor: IFormReadonlyModelAccessor, paths: readonly AbsoluteModelPath[]) {
        this.paths = paths;
        this.modelAccessor = modelAccessor;
    }

    public async query(filter?: DigestQueryFilter): Promise<PicklistQueryResponse> {
        const viewModels = Iterator.from(this.paths)
            .flatMap(x => MaskResolver.resolvePath(this.modelAccessor, x))
            .map(x => this.modelAccessor.getViewModel(x));
        // @ts-ignore Не совсем корректный код, надо исправлять код в gPathFilter
        const viewModelAsPicklistItem: PicklistDataItem[] = IterUtils.distinctBy(viewModels, x => x?.code);
        return gPathFilter(viewModelAsPicklistItem, filter);
    }
}
